module.exports = __webpack_public_path__ + "static/img/ecological_institute_cooperation_zj.5aea55a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ecological/ecological_institute_cooperation_zj.png
// module id = 2JLo
// module chunks = 0